import { useRegisterSW } from 'virtual:pwa-register/react'
import { useCallback, useState } from 'react'

export interface PWAStatus {
  needRefresh: boolean
  offlineReady: boolean
  updateServiceWorker: () => Promise<void>
  isUpdating: boolean
}

export function usePWA(): PWAStatus {
  const [isUpdating, setIsUpdating] = useState(false)

  const {
    needRefresh: [needRefresh],
    offlineReady: [offlineReady],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(registration) {
      if (import.meta.env.DEV) {
        console.log('[PWA] Service worker registered:', registration)
      }
      // Check for updates periodically (every hour)
      if (registration) {
        setInterval(
          () => {
            registration.update()
          },
          60 * 60 * 1000
        )
      }
    },
    onRegisterError(error) {
      console.error('[PWA] Service worker registration failed:', error)
    },
    onNeedRefresh() {
      if (import.meta.env.DEV) {
        console.log('[PWA] New content available')
      }
    },
    onOfflineReady() {
      if (import.meta.env.DEV) {
        console.log('[PWA] App is ready for offline use')
      }
    },
  })

  const handleUpdate = useCallback(async () => {
    setIsUpdating(true)
    try {
      await updateServiceWorker(true)
    } finally {
      // Give time for reload
      setTimeout(() => setIsUpdating(false), 1000)
    }
  }, [updateServiceWorker])

  return {
    needRefresh,
    offlineReady,
    updateServiceWorker: handleUpdate,
    isUpdating,
  }
}
